import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "wheel"
const WheelIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M12 1.5C17.799 1.5 22.5 6.201 22.5 12S17.799 22.5 12 22.5 1.5 17.799 1.5 12 6.201 1.5 12 1.5M3.658 8.62C3.235 9.664 3 10.804 3 12 3 16.605 6.458 20.4 10.919 20.935Q10.876 20.787 10.875 20.625V15.578C9.354 15.1 8.25 13.679 8.25 12Q8.25 11.62 8.323 11.261L3.958 8.861Q3.783 8.763 3.658 8.62M20.283 8.476Q20.186 8.57 20.063 8.644L15.66 11.184Q15.748 11.58 15.75 12C15.75 13.68 14.646 15.1 13.125 15.578V20.625Q13.123 20.787 13.08 20.935C17.541 20.4 21 16.605 21 12 21 10.75 20.744 9.558 20.283 8.476M12 9.75C10.757 9.75 9.75 10.757 9.75 12S10.757 14.25 12 14.25 14.25 13.243 14.25 12 13.243 9.75 12 9.75M12 3C8.983 3 6.314 4.486 4.68 6.765Q4.868 6.794 5.043 6.89L9.409 9.291C10.082 8.647 10.994 8.25 12 8.25 12.977 8.25 13.867 8.624 14.535 9.237L18.938 6.696Q19.06 6.626 19.19 6.589C17.548 4.409 14.939 3 12 3"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default WheelIcon
